module.exports = __webpack_public_path__ + "static/img-person4-47e882be6cf1bfe92c95c5c7f0e27d89.jpg";